// import initFilters from './sections/filters';
import { scrollToEls } from './global/scrollTo';
import headerInit from './sections/header/headerInit';
// import slickify from './dom/slickify';
import cookieWarning from './dom/cookieWarning';
import { clickToggle } from './global/clickToggle';
import dismissablesInit from './components/dismissables';
// import initLoadMore from './sections/products/loadMore';
import initialiseZoom from './components/productZoom';
import { initSort } from './sections/products/sort';
import addToCartBtnInit from './sections/cart/addToCart';
import lazyloadify from './global/lazyload';
import initLoadMore from './sections/products/loadMore';
import { ready, onShopifySectionLoad } from './global/instantiate';
import initAccordion from './components/accordion';
import { getSwatches, popuplateSwatches } from './global/swatches';
import {
  checkIfUserCanBeTracked,
  onConsentLoad,
  setTrackingConsent,
} from './dom/tracking';
import allowGTMTracking from './dom/allowGTMTracking';
import initLabelButtons from './global/labelButtons';
import animations from './dom/animations';
import formLabels from './dom/formLabels';
import actionCountry from './global/actionCountry';
import getCountry from './global/getCountry';
import nostoATC from './global/nostoATC';
import glidify, { glidifyMob } from './dom/glidify';
import initProductAccordions from './dom/accordion';
import subNavActive from './dom/subNavActive';
import focusSearch from './dom/focusSearch';
import { initScrollToProductInListing } from './global/initScrollToProductInListing';
import initAppHeight from './global/appHeight';

import readMore from './global/readMore';

import stockistFilters from './global/stockists-filters';
customElements.define('stockist-filters', stockistFilters);

// Helper functions
window.blubolt = {
  turboLinksActive: false,
  glides: [],
  stickers: {},
  dom: {
    nostoATC,
    glidify,
    glidifyMob,
    initialiseZoom,
    // initFilters,
  },
  consent: {
    checkIfUserCanBeTracked,
    setTrackingConsent,
  },
};

ready(() => {
  initAppHeight();
  initLabelButtons();
  lazyloadify();
  headerInit();
  initProductAccordions();
  nostoATC();
  animations();
  formLabels();
  clickToggle();
  dismissablesInit();
  cookieWarning();
  initSort();
  scrollToEls();
  focusSearch();
  addToCartBtnInit();
  initAccordion();
  glidify();
  glidifyMob();
  initLoadMore(() => {
    lazyloadify();
    popuplateSwatches(window.blubolt.swatches);
    window.ReloadSmartWishlist();
    console.info('Infinite scroll products loaded');
  });
  subNavActive();

  window.blubolt.swatches = getSwatches();
  popuplateSwatches(window.blubolt.swatches);

  getCountry(() =>
  //country
  {
    //anything reuqires geolocation can go here
    actionCountry();
  }
  );

  onConsentLoad((consent) => {
    if (consent) {
      //any tracking can be set up here
      //this fires on page load if a user has already consented or at the moment of consent
      console.info('user allows tracking!');
      allowGTMTracking();
    }
  });

  initScrollToProductInListing();
});

onShopifySectionLoad(() => {
  headerInit();
  clickToggle();
  lazyloadify();
  glidify();
});
